
namespace Matrix.Administration {

    @Serenity.Decorators.registerClass()
    export class PermissionSetDialog extends SiteEntityDialog<PermissionSetRow, any> {
        protected getFormKey() { return PermissionSetForm.formKey; }
        protected getIdProperty() { return PermissionSetRow.idProperty; }
        protected getLocalTextPrefix() { return PermissionSetRow.localTextPrefix; }
        protected getNameProperty() { return PermissionSetRow.nameProperty; }
        protected getService() { return PermissionSetService.baseUrl; }
        protected getDeletePermission() { return PermissionSetRow.deletePermission; }
        protected getInsertPermission() { return PermissionSetRow.insertPermission; }
        protected getUpdatePermission() { return PermissionSetRow.updatePermission; }

        protected form = new PermissionSetForm(this.idPrefix);
        private _showDefaultPermissionsInfo = false;
        private _lastReadDefaultPermissionsString: string;

        constructor() {
            super();

            noCommaValidationRule(this.form.PermissionSetCode, this.uniqueName);

            this.form.GrantedPermissions.getDefaultPermissions = () => {
                this._lastReadDefaultPermissionsString = this.form.DefaultPermissions.value;
                return this.splitPermissionsString(this._lastReadDefaultPermissionsString);
            }
        }

        protected arrange() {
            super.arrange();

            this.form.GrantedPermissions.element.css('height',
                Math.max(window.innerHeight - 520, 350) + 'px')
                .trigger('layout');
        }

        protected loadEntity(entity: PermissionSetRow) {
            super.loadEntity(entity);

            this.form.DefaultPermissions.value = (entity.DefaultPermissions || []).join('\n');
        }

        private splitPermissionsString(defaultPermissions: string) {
            return Q.replaceAll(defaultPermissions.trim(), '\r', '').split('\n')
                .map(x => Q.trimToNull(x))
                .filter(x => x != null);
        }

        protected getSaveEntity() {
            var entity = super.getSaveEntity();
            const defaultPermissionsString = entity.DefaultPermissions as unknown as string;

            if (typeof entity.DefaultPermissions == "string") {
                entity.DefaultPermissions = this.splitPermissionsString(entity.DefaultPermissions as string);
            }

            if (this.isEditMode() &&
                (this._lastReadDefaultPermissionsString !== defaultPermissionsString) &&
                    (entity.DefaultPermissions.length !== (this.entity.DefaultPermissions?.length ?? 0) ||
                    !this.entity.DefaultPermissions.every(x => entity.DefaultPermissions.some(y => x == y)))) {
                this._showDefaultPermissionsInfo = true;
            }

            return entity;
        }

        protected onSaveSuccess(response: Serenity.SaveResponse) {
            super.onSaveSuccess(response);

            if (this._showDefaultPermissionsInfo)
                Q.notifyInfo("Please note that only permissions that match these default permissions will be assigned to the permission set, existing permissions won't be modified.")
        }

        protected getLoadByIdRequest(id) {
            var opt = super.getLoadByIdRequest(id);
            opt.IncludeColumns = opt.IncludeColumns ?? [];
            opt.IncludeColumns.push(PermissionSetRow.Fields.GrantedPermissions);
            return opt;
        }

        protected useViewMode() {
            return false;
        }
    }
}